import React from 'react';
import { useObserver } from 'mobx-react';
import ContractInfo from './components/ContractInfo';

const ContractPage = () => {

  return useObserver(() => {
    return (<div className="flex-1">
      <div className="mr-8 my-8">
        <div className="mx-24">
          <ContractInfo />
        </div>
      </div>
    </div>)
  });
}

export default ContractPage
